import React, { useMemo } from 'react'
import { transformDetailWithPhone } from '../../utils/transformDetail'
import { Box, Button, Card, Typography } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import ContentCutIcon from '@mui/icons-material/ContentCut'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { mainGreen } from '../../utils/color'

const formatProductDetails = (order) => {
	if (order.source === 'zalo' || order.source === 'web') {
		return (
			order.line_items
				?.filter((item) => item.quantity != null)
				?.map((item) => `${item.quantity} x ${item.name}`)
				?.join('\n') || ''
		)
	}
	return order.productInfo
}

export default function GuestOrderItem({ item, handleSubmit, setOrderEditing, deleteGuestOrder, index }) {
	const orderRows = useMemo(
		() => (order) => {
			return [
				{ title: 'Nền tảng:', value: order.source.toUpperCase() },
				{ title: 'Thời gian tạo:', value: order.createdAt },
				{ title: 'Code:', value: order.code },
				{
					title: 'Thông tin khách hàng:',
					value: (
						<span
							dangerouslySetInnerHTML={{
								__html: transformDetailWithPhone(`${order.name} - ${order.phone}\n${order.address}`),
							}}></span>
					),
				},
				{ title: 'Thời gian giao:', value: order.shippingTime },
				{ title: 'Khối lượng:', value: `${order.quantity}Kg` },
				{ title: 'Chi tiết:', value: formatProductDetails(order) },
				{ title: 'Ghi chú:', value: order.note || 'Không có' },
				{
					title: 'Thanh toán:',
					value: order.payment === 'transfer' ? 'Chuyển khoản' : 'Tiền mặt',
					isPayment: true,
				},
				{ title: 'Tiền hàng:', value: `${order.bill.toLocaleString()}đ` },
				{ title: 'Phí giao hàng:', value: `${order.shippingTotal.toLocaleString()}đ` },
			]
		},
		[],
	)

	return (
		<Card sx={styles.orderCard} key={index}>
			<Box sx={styles.orderContent}>
				{index !== -1 && <Typography sx={styles.orderNumber}>ĐƠN {index + 1}</Typography>}

				<Box sx={styles.contentPadding}>
					{orderRows(item).map((row, idx) => (
						<Box key={idx} sx={styles.rowContainer}>
							<Typography sx={styles.rowTitle}>{row.title}</Typography>
							<Typography sx={styles.valueText} whiteSpace='pre-line'>
								{row.value}
							</Typography>
						</Box>
					))}
				</Box>

				{index !== -1 && (
					<Box sx={styles.footer}>
						<Button sx={styles.actionIconButton} onClick={() => handleSubmit(item)}>
							<CheckIcon sx={styles.checkIcon} />
						</Button>
						<Button sx={styles.actionIconButton} onClick={() => setOrderEditing(item)}>
							<ContentCutIcon sx={styles.editIcon} />
						</Button>
						<Button sx={styles.actionIconButton} onClick={() => deleteGuestOrder(item._id)}>
							<DeleteOutlineIcon sx={styles.deleteIcon} />
						</Button>
					</Box>
				)}
			</Box>
		</Card>
	)
}

const styles = {
	loadingOverlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: 9999,
	},
	loadingBackdrop: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
	},
	progressColor: {
		color: mainGreen,
		position: 'relative',
		zIndex: 1,
	},
	container: {
		maxWidth: 768,
		margin: '0 auto',
		px: 2,
		mt: '10px',
	},
	emptyCard: {
		padding: '10px',
		borderRadius: '16px',
		backgroundColor: 'white',
	},
	boldText: {
		fontWeight: 'bold',
	},
	orderCard: {
		borderRadius: '16px',
		mb: 2,
		backgroundColor: '#fff',
		boxShadow: 'rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px',
		overflow: 'hidden',
	},
	orderContent: {
		p: 2,
		position: 'relative',
	},
	orderNumber: {
		position: 'absolute',
		top: 8,
		right: 8,
		fontWeight: '500',
		bgcolor: '#4CAF50',
		color: 'white',
		padding: '4px 16px',
		borderRadius: '16px',
		fontSize: '0.875rem',
	},
	contentPadding: {
		p: 2,
	},
	rowContainer: {
		display: 'flex',
		alignItems: 'flex-start',
		py: 0.5,
	},
	rowTitle: {
		minWidth: '80px',
		fontSize: '0.95rem',
		color: '#666',
		// paddingTop: '2px',
	},
	valueText: {
		flex: 1,
		color: '#333 !important',
		fontWeight: '500 !important',
		fontSize: '0.95rem',
		lineHeight: '1.5 !important',
		textAlign: 'right',
	},
	paymentText: {
		flex: 1,
		color: '#4CAF50 !important',
		fontWeight: '600 !important',
		fontSize: '0.95rem',
	},
	deliveryNote: {
		color: '#4CAF50 !important',
		marginLeft: '8px',
		fontSize: '0.95rem',
		display: 'inline',
	},
	footer: {
		display: 'flex',
		gap: 1,
		mt: 2,
		pt: 2,
		borderTop: '1px solid #eee',
	},
	actionIconButton: {
		minWidth: 'unset',
		p: 1,
		borderRadius: '8px',
		'&:hover': {
			backgroundColor: '#f5f5f5',
		},
	},
	checkIcon: {
		color: '#4CAF50',
		fontSize: '1.2rem',
	},
	editIcon: {
		color: '#2196F3',
		fontSize: '1.2rem',
	},
	deleteIcon: {
		color: '#F44336',
		fontSize: '1.2rem',
	},
}

